import { Routes } from '@angular/router';
import {ProgramComponent} from "./program/program.component";
import {FaqComponent} from "./faq/faq.component";
import {EducationComponent} from "./education/education.component";



const infoRoute: Routes = [
  {
    path: 'program',
    component: ProgramComponent,
  },
  {
    path: 'faq',
    component: FaqComponent,
  },
  {
    path: 'infos-fur-anbieterinnen',
    component: EducationComponent,
  },
];

export default infoRoute;
